var render, staticRenderFns
import script from "./weappList.vue?vue&type=script&lang=js&"
export * from "./weappList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe32412",
  null
  
)

export default component.exports